import { ArcElement, Chart as ChartJS, Tooltip } from 'chart.js';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { useMutation } from 'react-query';
import AGButton from '../../../components/Button';
import Card from '../../../components/Card';
import { SearchByRegionRes } from '../../../models';
import { httpGET } from '../../../utils/ajaxHelper';
// import AGModal from '../modalViewDetail';
import AGModal from '../../../components/Modal';
import { getTruncatedTooltipLabel } from '../../../utils/chartHelpers';
import { CustomBackground } from '../../inboxMessage/addInquiryModal/addInquiry.style';
import { IInterestByLocationProps } from './interestByLocation.props';
import { BodyModal, Container } from './interestByLocation.styled';

ChartJS.register(ArcElement, Tooltip);

export const InterestByLocation = ({ interval, comOfferingType, orgFilter, isAllowMobile }: IInterestByLocationProps) => {
    const backgroundColor = process.env.REACT_APP_COLOR_OF_THE_CHART!.split(",");
    const [viewDetail, setViewDetail] = useState<boolean>(false);
    const [searchByRegion, setSearchByRegion] = useState<SearchByRegionRes[]>();
    const { mutate: searchByRegionFetch } = useMutation(
        (interval: number) =>
            httpGET({
                url: "/DashboardReport/search-by-location",
                params: {
                    interval, timeZone: new Date().getTimezoneOffset() / (-60),
                    currentDate: moment().format("MM/DD/YYYY").toString(),
                    offeringType: comOfferingType?.value,
                    orgId: orgFilter?.value
                }
            }),
        {
            onSuccess: (rs) => {
                setSearchByRegion(rs);
            },
        },
    );

    useEffect(() => {
        searchByRegionFetch(interval)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comOfferingType, orgFilter])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { searchByRegionFetch(interval) }, [interval]);
    if (!searchByRegion) {
        return null;
    }
    let resultArray: SearchByRegionRes[] = [];

    if (searchByRegion.slice(3).length > 1) {
        const firstThreeElements = searchByRegion.slice(0, 3);
        const otherElements = searchByRegion.slice(3).reduce((accumulator, currentValue) => {
            if (currentValue.count) {
                accumulator += currentValue.count;
            }
            return accumulator;
        }, 0);
        resultArray = resultArray.concat(firstThreeElements);
        const otherElement: SearchByRegionRes = {
            regionName: "Others",
            count: parseFloat(otherElements.toFixed(2))
        };
        resultArray.push(otherElement);
    } else {
        resultArray = [...searchByRegion];
    }

    return (
        <Card style={{ height: "100%" }}>
            <Container>
                <h2 className='mb-[16px]'>
                    Interest by Location
                </h2>
                {searchByRegion.length > 0 ? (<div className={`${comOfferingType && comOfferingType.value === 3 && "!max-w-[480px]"} wraper`}>
                    <div className='wraper-left '>
                        <AGModal
                            visible={viewDetail}
                            footer={<>
                                <AGButton onClick={() => setViewDetail(false)} type='Secondary'>Close</AGButton>
                            </>}
                            toggleModal={() => setViewDetail(false)}
                            title='Interest by Location'
                            setHeight={500}
                        >
                            <CustomBackground>
                                <BodyModal>
                                    <h2>
                                        Others:
                                    </h2>
                                    <ol>
                                        {searchByRegion.slice(3).map((e, index) => {
                                            return (
                                                <li
                                                    key={index}
                                                    className='item'>
                                                    <label>
                                                        {e.regionName}:
                                                    </label>
                                                    <div className='val'>{e.count}</div>
                                                </li>
                                            );
                                        })}
                                    </ol>
                                </BodyModal>
                            </CustomBackground>
                        </AGModal>
                        <Doughnut
                            id='InterestByLocation'
                            options={{
                                onClick: function (event, elements) {
                                    if (elements.length > 0) {
                                        const index = elements[0].index;
                                        if (index === 3 && searchByRegion.slice(3).length > 1) {
                                            setViewDetail(true);
                                        }
                                    }
                                },
                                responsive: true,
                                plugins: {
                                    tooltip: {
                                        callbacks: {
                                            title: function (context) {
                                                const label = context[0].label ?? "";
                                                return getTruncatedTooltipLabel(label, this.chart.width);
                                            },
                                        }
                                    }
                                },
                                clip: false,
                                layout: {
                                    padding: {
                                        left: 0,
                                        right: 4,
                                        top: 0,
                                        bottom: 0
                                    }
                                }
                            }}

                            data={{
                                labels: resultArray?.map(e => e.regionName),
                                datasets: [
                                    {
                                        borderRadius: 8,
                                        data: resultArray?.map(e => e.count),
                                        backgroundColor
                                    },
                                ],
                            }} />
                    </div>
                    <div className='wraper-right'>
                        {resultArray.map((e, i) => {
                            return <div className='item' key={i}>
                                <div className='left'>
                                    <span className={!isAllowMobile ? "mt-[16px]" : ""}>
                                        <Dot color={backgroundColor[i]} />
                                    </span>
                                    {e.regionName}
                                </div>
                                <div>
                                    {e.count}%
                                </div>
                            </div>
                        })}
                    </div>
                </div>) : (<div className="no-result">
                    No results found.
                </div>)}
            </Container>
        </Card>
    );
}


const Dot = ({ color }: any) => {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z"
            fill={color}
        />
    </svg>
}